import { makeStyles } from 'tss-react/mui';

// Styles
import { colors } from '../../../../styles/palette';

export const useStyles = makeStyles()((theme) => ({
  titleIcon: { marginRight: 8 },
  accent: { color: colors.gilead.primary1 },
  root: {
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }),
    },
  },
  title: {
    letterSpacing: '-0.4px',
  },
  infoText: {
    color: '#54565B',
    fontSize: 18,
    letterSpacing: '0.2px',
    width: '61%',
    [theme.breakpoints.down('lg')]: {
      width: '65%',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 16,
      width: 250,
      marginTop: theme.spacing(1),
    },
  },
  address: {
    color: '#54565B',
    fontSize: 18,
    letterSpacing: '0.2px',
    [theme.breakpoints.down('md')]: {
      fontSize: 16,
    },
  },
  error: {
    fontSize: 18,
    color: colors.gilead.primary1,
    marginBottom: theme.spacing(2.5),
  },
  label: {
    fontSize: 18,
    fontWeight: 700,
    marginTop: theme.spacing(5),
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
      marginTop: theme.spacing(3.75),
      marginBottom: theme.spacing(1),
    },
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 110,
    '& button': {
      width: 138,
    },
    '& button:nth-child(2)': {
      color: theme.palette.primary1,
    },
    [theme.breakpoints.down('lg')]: {
      alignItems: 'end',
      flex: 1,
      '& button:nth-child(1)': {
        width: 200,
      },
      '& button:nth-child(2)': {
        width: 90,
      },
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        alignItems: 'end',
        flex: 1,
      }),
    },
    [theme.breakpoints.down('md')]: {
      '& button': {
        height: 44,
      },
      '& button:nth-child(1)': {
        width: 204,
      },
      '& button:nth-child(2)': {
        paddingRight: 0,
        width: 92,
      },
    },
  },
}));
